import {DataHubService} from "../../modules/DataHubModule";
import {QbSyncStateDto} from "../../model/QbSyncStateDto";
import {QbXmlRequestDto} from "../../model/QbXmlRequestDto";
import {DisposeBag} from "../../modules/DisposeBag";
import {HookResult, Ng1Controller, Transition} from "@uirouter/angularjs";
import {ConfigService} from "../../modules/ConfigModule";

export default class QbSyncStatusController implements Ng1Controller {
    states: QbSyncStateDto[] = [];
    private requests: QbXmlRequestDto[] = [];
    private disposeBag = new DisposeBag();

    $onInit(): void {
        // this.reload();
    }
    uiCanExit(transition: Transition): HookResult {
        this.disposeBag.finalize();
        return undefined;
    }
    uiOnParamsChanged(newValues: any, $transition$: Transition): void {
    }


    constructor(private $dataHub: DataHubService, private $config: ConfigService) {
        $dataHub.bindQbSyncStateUpdated(() => this.states, this.disposeBag);
        $dataHub.bindQbXmlRequestUpdated(() => this.requests, this.disposeBag);
        $dataHub.onConnected(this.reload, this.disposeBag);
    }


    reload = () => {
        this.states = [];
        if (!this.$dataHub.isConnected) return;
        this.$dataHub.qbSyncStatusSubscribeAndQuery()
            .then(ret => this.states = ret);

        this.$dataHub.qbXmlRequestSubscribeAndQuery()
            .then(ret => this.requests = ret);
    }

    get pending() {
        return this.requests?.filter(x=>x.timeCompleted==null).length;
    }

    resync = (dto:QbSyncStateDto) => {
        let newDate = prompt("Resync from date? Leave blank for all");
        // @ts-ignore
        this.$dataHub.qbSyncStateResync(dto, newDate)
            .catch(this.$dataHub.defaultErrorHandler);
    }
    audit = (dto:QbSyncStateDto) => {
        this.$dataHub.qbSyncStateAudit(dto)
            .catch(this.$dataHub.defaultErrorHandler);
    }


}
